import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type { PlayerProfileFormProps } from './types';
import { asNumber, asString, setNumber, setString } from './helpers';

export const HockeyPlayerProfileForm: React.FC<PlayerProfileFormProps> = ({ value, onChange }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
    <FormControl fullWidth size="small">
      <InputLabel>Амплуа</InputLabel>
      <Select
        value={asString(value.position)}
        label="Амплуа"
        onChange={(e) => setString(value, 'position', e.target.value, onChange)}
      >
        <MenuItem value="goalie">Вратарь</MenuItem>
        <MenuItem value="defense">Защитник</MenuItem>
        <MenuItem value="center">Центр</MenuItem>
        <MenuItem value="wing">Крайний</MenuItem>
      </Select>
    </FormControl>
    <FormControl fullWidth size="small">
      <InputLabel>Хват</InputLabel>
      <Select
        value={asString(value.shoots)}
        label="Хват"
        onChange={(e) => setString(value, 'shoots', e.target.value, onChange)}
      >
        <MenuItem value="left">Левый</MenuItem>
        <MenuItem value="right">Правый</MenuItem>
      </Select>
    </FormControl>
    <TextField label="Номер" size="small" value={asNumber(value.number)} onChange={(e) => setNumber(value, 'number', e.target.value, onChange)} />
    <TextField label="Рост (см)" size="small" value={asNumber(value.heightCm)} onChange={(e) => setNumber(value, 'heightCm', e.target.value, onChange)} />
    <TextField label="Вес (кг)" size="small" value={asNumber(value.weightKg)} onChange={(e) => setNumber(value, 'weightKg', e.target.value, onChange)} />
  </Box>
);
